import { t } from "i18next";
import { ComputeFieldComponent } from "../../computeFields";
import { TitleState } from "../../types";
import { SeparatedList } from "./utils";

export const MainTitleCF: ComputeFieldComponent<{
  title: string;
  titleState?: Partial<TitleState>;
  styled?: boolean;
}> = ({ input, language }) => {
  const styled = input.styled ?? true;

  if (input.titleState?.none) {
    return styled ? (
      <i>{t("computeField.sansTitre", { lng: language })}</i>
    ) : (
      <>{t("computeField.sansTitre", { lng: language })}</>
    );
  }
  if (input.titleState?.unknown) {
    return <>{t("computeField.titreInconnu", { lng: language })}</>;
  }
  if (input.titleState?.notConfirmed) {
    return `[${input.title}]`;
  }
  return styled ? <i>{input.title}</i> : <>{input.title}</>;
};

export const DateCF: ComputeFieldComponent<{
  date?: string;
  unknownDate?: boolean;
}> = ({ input, language }) =>
  input.unknownDate || input.date == undefined ? (
    <>{t("computeField.sansDate", { lng: language })}</>
  ) : (
    <>{input.date}</>
  );

export const TitleCF: ComputeFieldComponent<{
  title: string;
  titleState?: Partial<TitleState>;
  date?: string;
  unknownDate?: boolean;
  subtitle?: string;
  otherTitle?: string;
  showDate?: boolean;
}> = ({ input, language, lineBreak = true, ...props }) => {
  return (
    <>
      <SeparatedList
        lineBreak={lineBreak}
        language={language}
        input={[
          <SeparatedList
            {...props}
            commaSeparated
            language={language}
            lineBreak={false}
            input={[
              <b>
                <MainTitleCF input={input} language={language} />
              </b>,
              (input.showDate ?? true) && (
                <DateCF input={input} language={language} />
              ),
            ]}
          />,
          input.subtitle,
          input.otherTitle,
        ]}
      />
    </>
  );
};

export const CreditCF: ComputeFieldComponent<{
  credit?: string;
}> = ({ input }) => {
  return input.credit ? <>{`${input.credit}`}</> : null;
};

export const TitlePhotoMasterCF: ComputeFieldComponent<{
  title: string;
  titleState?: Partial<TitleState>;
  date?: string;
  unknownDate?: boolean;
  location?: string;
  showDate?: boolean;
}> = ({ input, language, lineBreak = true, ...props }) => {
  return (
    <>
      <SeparatedList
        lineBreak={lineBreak}
        language={language}
        input={[
          <SeparatedList
            {...props}
            commaSeparated
            language={language}
            lineBreak={false}
            input={[
              <MainTitleCF input={input} language={language} />,
              input.location,
              (input.showDate ?? true) && (
                <DateCF input={input} language={language} />
              ),
            ]}
          />,
        ]}
      />
    </>
  );
};
